<template>
  <div dir="rtl">

    <!-- Update Notification Banner -->
    <UpdateNotification 
      :showUpdateNotification="showUpdateNotification"
      @performUpdate="performDirectUpdate"
    />

    <div>
      <div :class="isModalVisible == true || isModalReferral == true || isModalPishnahad == true ? 'custom' : ''"
        id="nav"
        v-if="($route.path == '/imagegeneration' || $route.path == '/videogeneration' || $route.path == '/' || $route.path == '/Gallery' || $route.path == '/characters' || $route.path == '/conversations' || $route.path == '/tools')"
        class="mobileRoomTopNav_3gjO3" style="border-radius: 0 0 20px 20px;">
        <div class="content_1QLZB" id="topnav">
          <div class="right_1XMld">

            <h3 style="color:white;margin-right: 20px;font-weight: bold;font-family: IRANSansWeb;"
              class="pageTitle_36g65">{{ this.$route.name }}</h3>

          </div>
          <div :style="isMobile == true ? 'margin-left:20px;' : 'margin-left:30px'" class="left_3cl7J">
            <div v-if="showPromotion == true" @click="gotoPromotion()"
              style="box-shadow:0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));display:flex;margin-top:5px;margin-bottom:5px;height:2.5em;margin-left:10px;text-align: center;border-radius: 30px;padding:5px;background: rgb(218, 45, 45);background: linear-gradient(90deg, rgb(228, 51, 51) 20%, #fd7691 100%);">
              <i class="fa-solid fa-gift"
                style="margin-right: 3px;margin-left:3px;font-size:13px;padding: 5px;color:white"></i>
              <h3 id="timer"
                style="margin-top:4px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:15px"
                class="pageTitle_36g65"></h3>
            </div>
            <div v-if="showPromotion == false && showCookie == true" @click="isModalVisible = true"
              style="cursor: pointer;box-shadow:0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));display:flex;margin-top:5px;margin-bottom:5px;height:2.5em;margin-left:10px;text-align: center;border-radius: 30px;padding:5px;background: rgb(97,83,204);background: linear-gradient(90deg, rgb(106, 94, 202) 20%, #fd7691 100%);">
              <i class="fa-solid fa-plus"
                style="margin-right: 3px;margin-left:3px;font-size:15px;padding: 5px;color:white"></i>
              <h3 style="margin-top:4px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:17px"
                class="pageTitle_36g65">{{ this.userInfo.credit > 25000 ? 'نامحدود' : this.userInfo.credit }} 🍪</h3>
            </div>

            <v-menu id="menuu" :location="'bottom right'">
              <template v-slot:activator="{ props }">
                <v-btn @click="test()" color="#6153cc" dark v-bind="props" style="min-width: 0px !important;">
                  <i id="menubar" class="fa-solid fa-bars" style="font-size: 20px;"></i>
                </v-btn>
              </template>
              <v-theme-provider with-background>

                <v-card id="menuuu" min-width="100">

                  <v-list>

                    <v-list-item>
                      <template v-slot:append>
                        <a class="btn btn-md btn-primary" style="width: 154px;">{{ this.mobile }}</a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="openMemoryManagement()" id="testbutton2" style="width: 154px;"
                          class="btn btn-md btn-primary testbutton">حافظه<i style="margin-left:5px"
                            class="fa-solid fa-brain"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="goto('/packages')" style="width: 154px;" class="btn btn-md btn-primary">🍪خرید کوکی<i
                            style="margin-left:5px" class="fa-solid fa-shopping-basket"></i></a>

                      </template>
                    </v-list-item>
                    <!-- <v-list-item>
                      <template v-slot:append>
                        <a @click="this.isModalReferral = true" style="width: 154px;"
                          class="btn btn-md btn-primary">دعوت
                          دوستان<i style="margin-left:5px" class="fa-regular fa-envelope"></i></a>

                      </template>
                    </v-list-item> -->
                    
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="showPoshtibani()" id="testbutton" style="width: 154px;"
                          class="btn btn-md btn-primary testbutton">پشتیبانی آنلاین<i style="margin-left:5px"
                            class="fa-solid fa-headset"></i><span id="unread_message"
                            style="margin-right:5px;padding: 3px 10px;border-radius: 100px;background: red;color: white;"></span></a>
                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="gotoInstagram()" id="testbutton2" style="width: 154px;"
                          class="btn btn-md btn-primary testbutton">اینستاگرام روبو<i style="margin-left:5px"
                            class="fa-brands fa-instagram"></i></a>

                      </template>
                    </v-list-item>
                    
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="this.isModalPishnahad = true" id="testbutton2" style="width: 154px;"
                          class="btn btn-md btn-info testbutton">ثبت پیشنهاد<i style="margin-left:5px"
                            class="fa-regular fa-star"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="showUpdateLogs()" style="width: 154px;" class="btn btn-md btn-info">
                         بروزرسانی ها <i style="margin-left:5px" class="fa-solid fa-history"></i>
                        </a>
                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="logout()" style="width: 154px;" class="btn btn-md btn-danger">خروج</a>

                      </template>
                    </v-list-item>


                  </v-list>

                </v-card>
              </v-theme-provider>
            </v-menu>


          </div>
        </div>
      </div>
      <router-view v-on:getuserData="getuserData()" v-on:showReferral="showReferral()" v-on:setCredit="setCredit()"
        v-on:setCredit1="setCredit1()" v-on:showCredit="isModalVisible = true" v-on:showOnboardingPopup="showOnboardingPopups"
        :class="isModalReferral == true || isModalVisible == true || isModalPishnahad == true ? 'custom' : ''" />
      <notifications position="bottom center" />
      
      <!-- Update Modal -->
      <UpdateModal 
        :isVisible="isUpdateModalVisible"
        :currentVersion="currentVersion"
        :newVersion="newVersion"
        :updateChanges="updateChanges"
        :isUpdated="isUpdateCompleted"
        @close="closeUpdateModal"
        @update="performUpdate"
      />
      
      <!-- Update Logs Modal -->
      <UpdateLogsModal 
        :isVisible="isUpdateLogsModalVisible"
        :updateLogs="updateLogs"
        @close="closeUpdateLogsModal"
      />
      <OnboardingPopup 
      v-if="showOnboardingPopup" 
      :isVisible="showOnboardingPopup" 
      :page="onBoardingPage"
      @close="closeOnboardingPopup" 
    />
      <!-- Memory Management Modal -->
      <MemoryManagementModal ref="memoryManagementModal" />
      
      <div :class="isModalReferral == true || isModalVisible == true || isModalPishnahad == true || isUpdateModalVisible == true || isUpdateLogsModalVisible == true ? 'custom' : ''"
        v-if="($route.path == '/imagegeneration' || $route.path == '/videogeneration' || $route.path == '/' || $route.path == '/Gallery' || $route.path == '/characters' || $route.path == '/conversations' || $route.path == '/tools')"
        class="mobileBottomNav_xZSxG"
        :style="isMobile == true ? 'border-radius: 20px 20px 0 0' : 'border-radius: 20px 20px 0 0;margin-left:15px'">
        <button @click="goto('/')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-solid fa-home" :style="$route.path == '/' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">خانه</div>
          </span>
        </button>
        <button @click="goto('/conversations')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i :class="$route.path == '/conversations' ? 'fa-solid' : 'fa-regular'" class="fa-message"
              :style="$route.path == '/conversations' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">گفتگو ها</div>
          </span>
        </button>
        <button @click="goto('/imagegeneration')" class="p-component tu-button btn-tertiary navItem_1fNF2"
          type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-regular fa-image" :style="$route.path == '/imagegeneration' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">عکس</div>
          </span>
        </button>
        <button @click="goto('/videogeneration')" class="p-component tu-button btn-tertiary navItem_1fNF2"
          type="button">
          <span class="tu-btn-content" tabindex="-1">
           
            <i class="fa-regular fa-video" :style="$route.path == '/videogeneration' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">ویدیو</div>
          </span>
        </button>
        <button @click="goto('/Gallery')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-regular fa-images" :style="$route.path == '/Gallery' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">گالری</div>
          </span>
        </button>
        <button @click="goto('/tools')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-solid fa-tools" :style="$route.path == '/tools' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">ابزارها</div>
          </span>
        </button>
      </div>
      <div v-if="isModalReferral || this.userInfo.showModalReferral" class="login-box">
        <div class="basket">
          <div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2" style="font-size:20px">دعوت دوستان</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: right;" class="font-12 text">با دعوت دوستان خود به روبو هم شما و هم دوستتان 50 کوکی 🍪 دریافت
              میکنید</p>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: right;" class="font-12 text">کافیه فقط کد خودتونو به دوستتون بدید و هنگام ثبت نام کد شمارو وارد کنه
            </p>
            <button v-if="isApplication" @click="shareCode()" type="submit" class="text-white btn btn-primary w-100"
              style="margin-bottom: 7px;">ارسال دعوتنامه
              <i id="menubar" class="fa-solid fa-share-from-square"></i>
            </button>
            <button type="submit" class="text-white btn btn-primary w-100" style="margin-bottom: 7px;"
              v-clipboard:copy="this.Referral"> کد دعوت: {{ this.Referral }}
              <i id="menubar" class="fa-solid fa-copy"></i>
            </button>
            <button type="submit" class="text-white btn btn-info w-100" style="margin-bottom: 7px;">تعداد دعوت شده: {{
              this.invites.length }}</button>
            <div class="d-flex flex-column" v-for="(item, index) in invites" :key="index">
              <a type="submit" style="margin-bottom: 7px; text-align:center"
                class="text-white btn btn-info btn-md w-100">{{
                  item }}</a>
            </div>

            <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="this.isModalReferral = false" type="submit"
                class="text-white btn btn-danger w-100">بستن</button>
            </div>
          </div> <!----><!---->
        </div>
      </div>
      <div v-if="isModalPishnahad" class="login-box">
        <div class="basket">
          <div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2" style="font-size:20px">ثبت پیشنهاد</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 text">{{ this.name }} عزیز نظرت برای ما مهمه!</p>
            <div class="text-button">
              <textarea autoresize autocomplete="off" type="text" autofocus="" id="textarea-input" v-model="chatbox"
                style="padding:10px;text-align: start;unicode-bidi: plaintext;overflow-y: auto;resize: none;width:100%;height:100%;min-height:110px;line-height:25px;display:block;font-size:17px;font-family: IRANSansWeb;color:white;outline: none;"
                placeholder="📝 پیشنهاد شما..." />
            </div>
            <div style="margin-top:10px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="sendSuggestion()" type="submit" class="text-white btn btn-primary w-100">ارسال</button>
            </div>
            <div style="margin-top:10px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="this.isModalPishnahad = false" type="submit"
                class="text-white btn btn-danger w-100">بستن</button>
            </div>
          </div> <!----><!---->
        </div>
      </div>
      <div v-if="isModalVisible" class="login-box">
        <div class="basket" style="padding:20px;">
          <div style="display:flex;justify-content: space-between;">
            <span style="font-size: 20px;color:white">بسته های کوکی شما</span>
            <i @click="isModalVisible = false" class="fa-solid fa-x"
              style="margin-top:5px;font-size: 20px;color:white;cursor: pointer;"></i>
          </div>
          <div style="margin-top:30px;">
            <!-- <div @click="showReferral()" //GhatiChanges
              style="display:flex;justify-content: space-between;border-radius: 10px;padding:20px;background-color: #5d62c6;cursor: pointer;">
              <span style="margin-top:20px;font-size: 1em;font-weight:bold;color:white">دوستاتو دعوت کن<br>50 کوکی🍪
                بگیر</span>
              <img :src="require('@/assets/img/invite1.png')" style="width:150px;height:100px">
            </div>
            -->
             <!-- <div v-if="this.credit == 0"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/gift.png')" style="padding:5px;margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">روزانه رایگان</span>
                  <span style="font-size: 13px;color:white">ریست: {{remaining}}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">{{ this.userInfo.credit }} از 5</span>
                </div>
                <div>
                </div>
              </div>
            </div>   -->
            <div v-if="this.credit > 25000 || this.packageId == 2"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/unlimitedcookie.jpg')" style="margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">معدن کوکی🍪</span>
                  <span style="font-size: 13px;color:white">معتبر تا {{ this.engheza }}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">نامحدود</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div v-else-if="this.credit > 0 && (this.packageId == 1 || this.packageId == 0)"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/cookiejar.jpg')" style="margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">جعبه کوکی🍪</span>
                  <span style="font-size: 13px;color:white">معتبر تا {{ this.engheza }}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">{{ this.userInfo.credit }}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div v-else-if="this.credit > 0 && this.packageId == 3"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/cookiechest.jpg')" style="margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">صندوق کوکی🍪</span>
                  <span style="font-size: 13px;color:white">معتبر تا {{ this.engheza }}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">{{ this.userInfo.credit }}</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            
            

            <div @click="goto('/packages')"
              style="margin-top:30px;text-align:center;padding:5px;border-radius: 5px;background-color: #E23E57;color:white;font-weight: bold;font-size:20px;cursor:pointer">
              <i style="padding: 10px;color:white" class="fa-solid fa-shopping-basket"></i>همین حالا خرید کنید!
            </div>
          </div>
        </div>
      </div>

      
    </div>
  </div>
</template>
<script>
import router from './router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
import UpdateModal from './components/UpdateModal.vue';
import UpdateLogsModal from './components/UpdateLogsModal.vue';
import UpdateNotification from './components/UpdateNotification.vue';
import MemoryManagementModal from './components/MemoryManagementModal.vue';
/* eslint-disable */
import OnboardingPopup from "@/components/OnboardingPopup.vue";

export default {
  components: {
    UpdateModal,
    UpdateLogsModal,
    UpdateNotification,
    MemoryManagementModal,
    OnboardingPopup,
  },

  data() {
    return {
      isPoshtibani: false,
      raminname: "ramin",
      showOnboardingPopup: false,
      mobile: '',
      value: 1,
      credit: 0,
      onBoardingPage: 1,
      promotionDate: null,
      intervalId: null,
      engheza: '',
      invites: [],
      remaining: null,
      name: '',
      chatbox: '',
      showPromotion: false,
      isModalPishnahad: false,
      freeCredit: 0,
      packageId: 0,
      showCookie: false,
      Referral: '',
      isModalVisible: false,
      isModalReferral: false,
      // Update system variables
      isUpdateModalVisible: false,
      isUpdateLogsModalVisible: false,
      showUpdateNotification: false,
      isUpdateCompleted: false,
      currentVersion: '1.6.17',
      newVersion: '',
      updateLogs: [
      {
      version: '1.6.17',
          date: '24 بهمن 1404',
          changes: [
            'تغییر کامل ساخت ویدیو',
            'اضافه شدن افزودن عکس به ساخت ویدیو',
            'اضافه شدن صدا به ساخت ویدیو',
            'بهبود سرعت ساخت ویدیو',
            'بهبود مدل ادیت عکس',
            'اضافه شدن مدل GPT 5.1 و GPT 5.2',
            'اضافه شدن مدل Gemini 3 Pro',
            'اضافه شدن مدل های Sonnet 4.5 و Opus 4.5 و Opus 4.6',
            'اضافه شدن مدل Grok 3 و Grok 4.1',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده',
          ]
      },
      {
      version: '1.6.16',
          date: '8 بهمن 1404',
          changes: [
            'وصل شدن تمام مدل های آنلاین و بین الملل',
            'بهبود سرعت',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده',
          ]
      },
      {
      version: '1.6.15',
          date: '23 دی 1404',
          changes: [
            'اضافه شدن مدل هوش مصنوعی برای استفاده هنگام اینترنت ملی',
            'بهبود سرعت',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده',
          ]
      },
      {
      version: '1.6.14',
          date: '21 آبان 1404',
          changes: [
            'بهبود سرعت',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده',
          ]
      },
      {
          version: '1.6.13',
          date: '23 مهر 1404',
          changes: [
            'اضافه شدن ابزار ها',
            'اضافه شدن تغییر شخصیت به صفحه گفتگو',
            'بهبود رابط کاربری',
          ]
        },  
      {
          version: '1.6.12',
          date: '29 شهریور 1404',
          changes: [
            'اضافه شدن مدل روبو',
            'اضافه شدن سبک های جدید به ادیت عکس',
            'اضافه شدن آموزش اولیه',
            'اضافه شدن نماد های روبو',
            'بهبود حافظه',
            'بهبود رابط کاربری',
          ]
        },   
      {
          version: '1.6.11',
          date: '18 شهریور 1404',
          changes: [
            'اضافه شدن حافظه به هوش مصنوعی',
            'اضافه شدن تاریخچه به ادیت عکس',
            'اضافه شدن سبک های جدید به ادیت عکس',
            'بهبود سرعت و کیفیت ادیت عکس',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده'
          ]
        },      
        {
          version: '1.6.10',
          date: '28 مرداد 1404',
          changes: [
            'اضافه شدن تولید ویدیو با هوش مصنوعی',
            'اضافه شدن هوش مصنوعی GPT 5',
            'اضافه شدن هوش مصنوعی GPT 5-mini',
            'اضافه شدن هوش مصنوعی GPT 5-nano',
            'بهبود رابط کاربری',
            'رفع مشکلات گزارش شده'
          ]
        }
      ],
      updateChanges: [],
      pendingUpdate: null,
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
    }
  },
  methods: {
    closeOnboardingPopup() {
      this.showOnboardingPopup = false;
    },
    showOnboardingPopups(page) {
      console.log("Page:"+ page)
      this.onBoardingPage = page;
      this.showOnboardingPopup = true;
    },
    gotoInstagram() {
      if (this.isApplication == true)
        Android.Download("instagram://user?username=roboo.ir");
      else
        window.open("https://www.instagram.com/roboo.ir");
    },
    gotoPromotion() {
      router.push("/promotion");
    },
    sendSuggestion() {
      if (this.chatbox != "") {
        let json =
        {
          token: localStorage.getItem("token"),
          comment: this.chatbox,
          subject: "pishnahad"
        }
        axios.post("https://api.roboo.ir/api/Suggestion/AddSuggestion", json).then((response) => {
          if (response.data.status == 0) {
            this.chatbox = "",
              this.isModalPishnahad = false;
            notify({
              title: "پیشنهادات",
              text: response.data.message,
              type: "success"
            });
          }
          else {
            notify({
              title: "خطا",
              text: response.data.message,
              type: "error"
            });
          }
        });
      }
      else {
        notify({
          title: "پیشنهادات",
          text: "متن پیشنهادی شما خالی است!",
          type: "error"
        });
      }
    },
    logout() {
      localStorage.setItem('token', "");
      router.push('login');
    },
    shareCode() {
      var text = "دوست گرامی، شما از طرف «" + this.name + "» عزیز به اپلیکیشن روبو دعوت شده اید." + "\nروی لینک زیر کلیک کرده و اپلیکیشن روبو را نصب کنید تا با پیشرفته ترین هوش مصنوعی ایرانی در موضوعات مختلف گفتگو کرده یا عکس دلخواهتان را بسازید." +
        "\nکد «" + this.Referral + "» را در قسمت کد معرف وارد کنید و 50 اعتبار رایگان، هدیه بگیرید." + "\nhttps://roboo.ir\n روبو پیشرفته ترین ربات هوش مصنوعی چت و عکس ایرانی";
      // eslint-disable-next-line
      Android.ShareText(text);
    },
    setCredit() {
      this.showCookie = false;
      this.showCookie = true;
      if (this.userInfo.credit <= 0) {
        this.getuserData();
      }
    },
    setCredit1() {
      this.showCookie = false;
      this.showCookie = true;
    },
    showReferral() {
      this.isModalVisible = false;
      this.isModalReferral = true;
    },
    goto(route) {
      if(route == '/packages' && this.credit > 50)
    {
        notify({
              title: "خطا",
              text: "امکان خرید بسته جدید با بسته فعال وجود ندارد",
              type: "error"
            });
            return;
    }
      if (this.isModalVisible == true)
        this.isModalVisible = false;
      router.push(route);
    },
    showPoshtibani() {
      Goftino.open()
    },
    getuserData() {
      //this.chats=[];
      this.history = [];
      axios.get("https://api.roboo.ir/api/Users/GetUserDataC?token=" + localStorage.getItem("token"))
        .then(response => {
          if (response.data.status == 0) {
            this.mobile = response.data.mobile;
            this.name = response.data.name;
            this.packageId = response.data.package;
            this.credit = response.data.credit;
            this.freeCredit = response.data.freeCredit;
            this.engheza = response.data.packageEndDate;
            this.invites = response.data.referrals;
            this.Referral = response.data.referral;
            this.userInfo.mobile = this.mobile;
            this.userInfo.credit = this.credit == 0 ? response.data.freeCredit : this.credit;
            this.userInfo.engheza = this.engheza;
            this.userInfo.Referral = this.Referral;
            this.userInfo.invites = this.invites;
            this.showCookie = false;
            this.showCookie = true;
            if (this.isApplication) {
              Android.setToken(localStorage.getItem("token"));
            }
            // if (element2.length > 0) {
            //   window.$crisp.push(["set", "session:data", [[
            //     ["user-credit", this.credit.toString()],
            //     ["user-expire", this.engheza.toString()],
            //     ["user-invites", this.invites.length.toString()],
            //     ["user-mobile", this.mobile.toString()]
            //   ]]]);
            // }
            // else {
            //   setTimeout(() => {
            //     window.$crisp.push(["set", "session:data", [[
            //       ["user-credit", this.credit.toString()],
            //       ["user-expire", this.engheza.toString()],
            //       ["user-invites", this.invites.length.toString()],
            //       ["user-mobile", this.mobile.toString()]
            //     ]]]);
            //   }, 3000);
            // }
          }
          else {
            //NotSuccess
            router.push("login");
          }
        }).catch(function (error) {
          console.log(error);
          console.log(error.code);
          if (!error.response) {
            // network error (server is down or no internet)
          } else {
            // http status code
            console.log(error.response.status)
            // data from server while error
            console.log(error.response.data)
          }
        });
    },
    gotoPackages() {
      router.push("/packages");
    },
    test() {
      let element = document.getElementById('menubar');
      if (element != null) {
        element.classList.toggle('fa-bars');
        element.classList.toggle('fa-x');
      }
    },
    sendFirebaseToken(firebaseToken) {
      console.log("HereRamin");
      var localToken = localStorage.getItem("firebaseToken");
      if (localToken != null) {
        if (localToken == firebaseToken)
          return;
      }
      console.log("TestRamin" + firebaseToken);
      let json =
      {
        token: localStorage.getItem("token"),
        firebaseToken: firebaseToken,
      }
      axios.post("https://api.roboo.ir/api/Users/AddFirebaseToken", json).then((response) => {
        if (response.data.status == 0) {
          localStorage.setItem("firebaseToken", firebaseToken);
        }
      });
    },
    
    // Update system methods
    performDirectUpdate() {
      // Hide notification and perform update directly
      this.showUpdateNotification = false;
      
      // Add to update logs
      this.addUpdateLog({
        version: this.newVersion || 'نسخه جدید',
        date: new Date().toLocaleDateString('fa-IR'),
        changes: this.updateChanges
      });
      
      // Set flag for post-update detection
      localStorage.setItem('updateCompleted', this.newVersion || 'نسخه جدید');
      
      // Reload page after a short delay
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    },
    
    showUpdateModal(updateData) {
      if (updateData) {
        this.newVersion = updateData.newVersion || 'نسخه جدید';
        this.updateChanges = updateData.changes || [
          'بهبود عملکرد کلی اپلیکیشن',
          'رفع مشکلات گزارش شده',
          'بهبود رابط کاربری',
          'بهینه‌سازی سرعت بارگذاری'
        ];
        this.pendingUpdate = updateData.registration;
      }
      this.isUpdateModalVisible = true;
      this.showUpdateNotification = false; // Hide notification when modal is shown
    },
    
    closeUpdateModal() {
      // Allow closing if update is completed or no pending update
      if (this.isUpdateCompleted || !this.pendingUpdate) {
        this.isUpdateModalVisible = false;
        this.isUpdateCompleted = false;
      }
    },
    
    performUpdate() {
        // Add to update logs
        this.addUpdateLog({
          version: this.newVersion,
          date: new Date().toLocaleDateString('fa-IR'),
          changes: this.updateChanges
        });
        
        // Set flag for post-update detection
        localStorage.setItem('updateCompleted', this.newVersion);
        
        // Mark update as completed and show success state
        this.isUpdateCompleted = true;
        
        // Reload page after a short delay
        setTimeout(() => {
          window.location.reload(true);
        }, 1000);
    },
    
    showUpdateLogs() {
      this.isUpdateLogsModalVisible = true;
    },
    
    closeUpdateLogsModal() {
      this.isUpdateLogsModalVisible = false;
    },
    
    addUpdateLog(log) {
      // Add new log at the beginning
      this.updateLogs.unshift(log);
      
      // Keep only last 20 logs
      if (this.updateLogs.length > 20) {
        this.updateLogs = this.updateLogs.slice(0, 20);
      }
    },
    
    openMemoryManagement() {
      if (this.$refs.memoryManagementModal) {
        this.$refs.memoryManagementModal.open();
      }
    },
    
    initializeUpdateSystem() {
      // Listen for service worker update events
      window.addEventListener('serviceWorkerUpdate', (event) => {
        const { type, data } = event.detail;
        
        if (type === 'updated') {
          // Show update notification banner first
         // this.showUpdateNotification = true;
          
          // Store update data for later use
          this.pendingUpdate = data.registration;
          this.newVersion = data.newVersion || 'نسخه جدید';

          this.performUpdate();
        }
      });
      
      // Check if this is a post-update reload
      const updateCompleted = localStorage.getItem('updateCompleted');
      if (updateCompleted) {
        // Show success modal
        //GhatiChanges
        this.isUpdateModalVisible = false;
        this.isUpdateCompleted = false;
        this.newVersion = updateCompleted;
        this.updateChanges = this.updateLogs[0]?.changes || [];
        
        // Clear the flag
        localStorage.removeItem('updateCompleted');
      }
      
      // Update logs are now managed manually in the data section
    },
  },
  mounted() {
    var that = this;
    this.updateChanges = this.updateLogs[0].changes;
    //if (this.isMobile == false) {
    //  window.location = "https://newpanel.roboo.ir"
    //}
    window.ramintoken = function (tok) {
      that.sendFirebaseToken(tok)
    }
    setInterval(() => {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(24, 0, 0, 0); // next 12 AM
      const diff = Math.floor((midnight - now) / 1000);

      const h = String(Math.floor(diff / 3600)).padStart(2, "0");
      const m = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
      const s = String(diff % 60).padStart(2, "0");

      this.remaining = `${h}:${m}:${s}`;
    }, 1000);
    var token = localStorage.getItem("token");
    if (token != null && token != "") {

      this.getuserData();
      function updateTimer() {
        var timer = document.getElementById("timer");
        if (timer == null) {
          //clearInterval(that.intervalId);
          return;
        }
        var future = that.promotionDate;
        var now = new Date();
        var diff = future - now;

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor(diff / (1000 * 60 * 60));
        var mins = Math.floor(diff / (1000 * 60));
        var secs = Math.floor(diff / 1000);

        var h = hours - days * 24;
        var m = mins - hours * 60;
        var s = secs - mins * 60;

        timer.innerText =
          h + ':' + m + ':' + s;

        if (h == 0 && m == 0 && s == 1)
          that.showPromotion = false;

      }
      window.ramincode = function (tok) {
        that.setCode(tok)
      }

      var promotion = localStorage.getItem("promotionDate");
      var nowDate = new Date();
      if (promotion != null && Date.parse(promotion) > nowDate) {
        this.promotionDate = Date.parse(promotion);
        this.showPromotion = true;
        updateTimer();
        this.intervalId = setInterval(updateTimer, 1000);
      }
      const config = { headers: { 'Content-Type': 'application/json' } };
      axios.post("https://api.roboo.ir/api/Users/UserDate", localStorage.getItem("token"), config).then(response => {
        setTimeout(() => {
          if (response.data == "3" && localStorage.getItem("promotionDate") == null && this.credit < 70) {
            var date = new Date();
            //date.setTime(date.getTime() + 1000 * 60);

            date.setDate(date.getDate() + 1);
            this.promotionDate = date;
            this.showPromotion = true;
            updateTimer();
            this.intervalId = setInterval(updateTimer, 1000);
            localStorage.setItem("promotionDate", date);
            router.push("/promotion");
          }
        }, 5000)
      });

    }
    else {
        router.push("/login");
    }

    document.getElementsByClassName('v-overlay-container')[0].onclick = function (e) {
      if (e.target != document.getElementById('menuu')) {
        let element = document.getElementById('menubar');
        if (element != null) {
          element.classList.add('fa-bars');
          element.classList.remove('fa-x');
        }
      }
    }
    document.getElementById('app').onclick = function (e) {
      if (e.target != document.getElementById('menuu')) {
        let element = document.getElementById('menubar');
        if (element != null) {
          element.classList.add('fa-bars');
          element.classList.remove('fa-x');
        }

      }

    }

    // Initialize update system
    this.initializeUpdateSystem();
    
    // Set up global memory management access
    window.openMemoryManagement = this.openMemoryManagement;
    
    // Listen for custom memory management events
    window.addEventListener('openMemoryManagement', this.openMemoryManagement);
    
    //Goftino
    !function () { var i = "de2QR2", a = window, d = document; function g() { var g = d.createElement("script"), s = "https://www.goftino.com/widget/" + i, l = localStorage.getItem("goftino_" + i); g.async = !0, g.src = l ? s + "?o=" + l : s; d.getElementsByTagName("head")[0].appendChild(g); } "complete" === d.readyState ? g() : a.attachEvent ? a.attachEvent("onload", g) : a.addEventListener("load", g, !1); }();
    window.addEventListener('goftino_ready', function () {
      Goftino.setWidget({
        hasIcon: false,
        counter: '#unread_message'
      });
      setTimeout(() => {
        Goftino.setUser({
          name: that.name,
          about:"1.6.7 | " + that.credit + " | " + that.engheza + " | ",
          phone: that.mobile,
          forceUpdate: true
        });
      }, 5000);
    });
    window.addEventListener('goftino_getMessage', function (d) {
      if (that.isPoshtibani == false) {
        var message_type = d.detail.type;
        // "text" , "file" , "voice" , "question"
        if(message_type != "question")
      {
        var message_content = d.detail.content;
        notify({
          title: "پشتیبانی آنلاین",
          text: "پیام جدید: " + message_content,
          type: "info"
        });
      }
    }
    });
    window.addEventListener('goftino_openWidget', function () {
      that.isPoshtibani = true;
    });
    window.addEventListener('goftino_closeWidget', function () {
      that.isPoshtibani = false;
    });



    //localStorage.removeItem("promotionDate");
  },
  
  beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('openMemoryManagement', this.openMemoryManagement);
  }
}
/* eslint-disable */

// window.open = function (open) {
//   return function (url, name, features) {
//     // set name if missing here
//     name = name || "default_window_name";
//     return open.call(window, url, name, features);
//   };
// }(window.open);
</script>
<style scoped>
@import url('@/assets/topnav.css');
@import url('@/assets/fontawesome/css/all.min.css');

#unread_message:empty {
  display: none;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('./assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('./assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

body {
  background-color: #212529;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgb(41, 41, 41);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

}

@media(min-width:768px) {
  .login-box {
    top: 50%;
    left: 50%;
    position: fixed;
    width: 30vw;
    padding: 10px;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;

  }
}

@media(max-width:767px) {
  .login-box {
    top: 50%;
    left: 50%;
    position: fixed;
    width: 90vw;
    padding: 10px;
    transform: translate(-50%, -50%);
    z-index: 10000;
    background-color: rgb(24, 24, 24);
    box-sizing: border-box;
    box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
    border-radius: 10px;

  }
}

.custom {
  filter: blur(5px);
}
</style>